export enum PackageCardType {
  Wide = "wide",
}
